import {ActionTypes} from "./types";

const INITIAL_STATE = {
  regions: undefined
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_REGIONS:
      return {
        ...state,
        regions: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;